angular.module('mercury.modules.stock.recipe')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.Recipe', {
    url: '/recipes',
    templateUrl: 'modules/stock/recipe/list.tpl.html',
    controller: 'StockRecipeListCtrl'
  });

  $stateProvider.state('Stock.RecipeAdd', {
    url: '/recipes/add',
    templateUrl: 'modules/stock/recipe/edit.tpl.html',
    controller: 'StockRecipeEditCtrl',
    data: {
      menuLinkState: 'Stock.Recipe'
    }
  });

  $stateProvider.state('Stock.RecipeEdit', {
    url: '/recipes/edit/:id',
    templateUrl: 'modules/stock/recipe/edit.tpl.html',
    controller: 'StockRecipeEditCtrl',
    data: {
      menuLinkState: 'Stock.Recipe'
    }
  });

  $stateProvider.state('Stock.RecipeView', {
    url: '/recipes/view/:id?print',
    templateUrl: 'modules/stock/recipe/view.tpl.html',
    controller: 'StockRecipeEditCtrl',
    data: {
      menuLinkState: 'Stock.Recipe'
    }
  });
}]);
